/**
 * Shown when we waited on an approval run and it turned the quote down without
 * asking anybody. The publish button is closed for a quote we already know the
 * rules reject, so getting here means the prediction was wrong - and closing
 * the modal with nothing said would leave somebody believing they'd published.
 */
export const PUBLISH_AUTO_REJECTED_MESSAGE: string =
  "This quote doesn't pass the approval rules, so it wasn't published"
